export default __webpack_public_path__ + "static/media/containership.b3b397ba.svg";